import React, { useEffect, useState } from 'react';
import ContainerHeader from 'components/ContainerHeader';
import CardBox from 'components/CardBox';
import API from 'util/Api';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'lodash';
import moment from 'moment'
import RenewFilter from '../RenewFilter'
import ReportTable from 'components/ReportTable/index';
import RenewDialog from '../RenewDialog';
import PopUpDialog from 'components/PopUpDialog';
import SnackBar from 'components/SnackBar';


const EVSubscription = (props) =>{
    const [locations, setLocations] = useState([]);
    const [table, setTable] = useState([]);
    const [clients, setClients] = useState([]);
    const [subscription, setSubscription] = useState({});
    const subscription_type = ["User","Client"];
    const [selectedSubscription, setSelectedSubscription] = useState([]);
    const [formInputs, setFormInputs] = useState({});
    const [state, setState] = useState({appState:'loading', loading:false });
    const [renewDialog, setRenewDialog] = useState({isShowing:false, dialogType:'', header:'', message:'', errorMessage:'' });
    const [snackBar, setSnackBar] = useState({open: false, msg: "", type: "success"});

    const [dialog, setDialog] = useState({
        open:false,
        dialogContent:'',
        dialogAgreeBtnTxt:'',
        dialogDisAgreeBtnTxt:'',
        dialogHeader:'',
        dialogType:'',
        isBtnDisabled:''
    });

    useEffect( () => {         
        API.get('evSubscriptionConfig')
        .then((res) => {   
            console.log('response data',res.data.data)
            setLocations(res.data.data.locations);
            setClients(res.data.data.clients);
            setState(prevState => ({...prevState, appState:'active'}));
        })
        .catch((err) => {
            // got an error
            setSnackBar({open:true, msg:"Please try again", type:'error'})
        })
    },[])

    const getData = (params) => {
        console.log("getData",params)

        setState(prevState => ({...prevState, appState:'waiting', locationName: params.name}))
        API.get('evSubscriptions?data='+JSON.stringify(params))
        .then((res)=> {
            setState(prevState => ({...prevState, appState:'active'}));
            setFormInputs(params);
            setTable(res.data.data);
        })
        .catch((err)=> {
            setSnackBar({open:true, msg:"Please try again", type:'error'})
        })
    }

    const renewSubscription = (params) => {
        console.log("renew_subscription",params)
        let subscription = _.cloneDeep(params);
        const oneMonthAgo = moment(moment().subtract(1, 'M'), 'DD-MM-YYYY HH:mm');
        const endDate = moment(params.end, 'DD-MM-YY hh:mm A');
        if (endDate.isBefore(oneMonthAgo)) {
            const dateObj = moment();
            subscription.start = moment(dateObj,'DD-MM-YY HH:mm A').startOf('day').toDate();
            subscription.end = moment(dateObj,'DD-MM-YY HH:mm A').add(1,'M').endOf('day').toDate();
            subscription.minStart = moment(dateObj,'DD-MM-YY HH:mm A').subtract(1,'M').startOf('day').toDate();
        } else {
            if (endDate.format('HH:mm') === '23:59') {
                // If time is 11:59 PM, add 1 day and set the time to 00:00 (start of the day)
                subscription.start = moment(params.end,'DD-MM-YY HH:mm A').add(1, 'days').startOf('day').toDate(); // This will give you the next day at 12:00 AM
            } else {
                // Otherwise, add 1 sec to the given time
                subscription.start = moment(params.end,'DD-MM-YY HH:mm A').add(1, 'second').toDate(); // This will give you the same day with 1 minute added
            }
            subscription.end = moment(params.end,'DD-MM-YY HH:mm A').add(1,'M').endOf('day').toDate();
            subscription.minStart = moment(params.end,'DD-MM-YY HH:mm A').subtract(1,'M').toDate();
        }
        setRenewDialog(prevState => ({...prevState, isShowing:true, dialogType:'renew'}));
        setSubscription(subscription);
    }
   
    const handleClose = () => {
        setRenewDialog(prevState => ({...prevState, isShowing: false, message:'', header:'', errorMessage:''}));
        setSubscription({});
    }
    const onEnable = (params,checked) => {
        var text = checked ? 'Are you sure you want to activate subscription ?' : 'Are you sure you want to deactivate subscription?'
        var header = checked ? 'Activate Subscription' : 'Deactivate Subscription'
        console.log('onEnable params__',params,checked);
        setSelectedSubscription({...params, selected_client:formInputs.client});
        setDialog(prevState => ({...prevState, open:true, dialogAgreeBtnTxt:'Confirm', dialogDisAgreeBtnTxt:'Cancel', dialogContent:text, dialogHeader:header}))
    }
    const onEdit = (params) => {
        console.log("onEdit-",params)
        let subsType=params.update_type_hidden // subscription type
        if(subsType==='client_subscription'){
            const clientData = {clcs_id:params.clcs_id_hidden, client_name:params.name,client_id:params.client_id_hidden,locationId:params.location_id_hidden}
            setSubscription(clientData);
            setRenewDialog(prevState => ({...prevState, isShowing:true, header:'Update Client Subscription', dialogType:'update_client_subscription'}));
        }else{
            let id = (params.ccu_id_hidden)?params.ccu_id_hidden:params.clus_id_hidden

            window.open(`/app/ezcharge/update-ev-subscription/${id}/${subsType}/${state.locationName}/${params.location_id_hidden}`, '_blank');
        }
    }
    const handleConfirmDialogClose = () => {
        setDialog(prevState => ({...prevState, open:false,dialogAgreeBtnTxt:'',dialogDisAgreeBtnTxt:'',dialogContent:'',dialogHeader:''}));
        setSelectedSubscription({});
    }
    const updateSubscription = () => {
        setDialog(prevState => ({...prevState, isBtnDisabled:true}));
        API.post("evSubscriptionStatus", JSON.stringify(selectedSubscription))
        .then((res)=> {
            setDialog(prevState => ({...prevState, open:false, dialogAgreeBtnTxt:'', dialogDisAgreeBtnTxt:'', dialogContent:'', dialogHeader:'', isBtnDisabled:false}));
            setSnackBar({open:true, msg:`${selectedSubscription.user_name}'s Subscription ${selectedSubscription.active_hidden == '1' ? 'deactivated' : 'activated'} successfully`, type:'success'});
            setSelectedSubscription({});
            setTable(res.data.data);
        })
        .catch((err)=>{
            setSnackBar({open:false, msg:err.response.data.msg, type:'error'});
            // open:false,
            console.log("post config error ", err)
        })
    }
    const updateClientSubscription = (inputs) => {
        console.log("updateClientSubscription",inputs)
        API.put("evSubscription", {...inputs,type:'client'}).then((res) => {
            setRenewDialog(prevState => ({...prevState, message:res.data.msg, errorMessage:''}));
            setTable(res.data.data);
                setTimeout(function(){
                    handleClose()
                },2000);
        }).catch((err) => {
            setRenewDialog(prevState => ({...prevState, errorMessage:err.response.data.msg}));
            console.log("post config error ", err);
        });
    } 

    const renewSubscriptionData = (params) => {
        params['selected_client'] = formInputs.client;
        console.log("renewSubscription__", params)
        setState(prevState => ({...prevState, loading:true}));
        API.post("evSubscriptionsRenew", JSON.stringify(params))
            .then((res)=> {
                setRenewDialog(prevState => ({...prevState, message:res.data.msg, errorMessage:''}));
                setState(prevState => ({...prevState, loading:false}));
                setTable(res.data.data)
                setTimeout(function(){
                    handleClose()
                },2000);
            })
            .catch((err)=>{
                setState(prevState => ({...prevState, loading:false}));
                setRenewDialog(prevState => ({...prevState, errorMessage:err.response.data.msg}));
                console.log("post config error ", err)
            })
    }
    
    return (
        state.appState == 'loading' ?
            <div
                style= {{ 
                    position: "absolute", 
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent:"center"
                }}
            >
                <CircularProgress color="secondary" size={50}/>
            </div>
        : <div>
            <ContainerHeader title="Renew EV Subscription" match={props.match} />    
            <div className="row">
                <CardBox styleName="col-12">
                    <RenewFilter 
                        locations={locations} 
                        clients = {clients}
                        getReportData={getData} 
                        subscription_type={subscription_type}
                        />
                </CardBox>
            </div>
            { state.appState==='waiting' ?
                    <div><LinearProgress color="primary"/><LinearProgress color="primary"/></div>
                : <React.Fragment>
                    { Object.keys(table).length >0 &&
                        <ReportTable downloadCSVBtn onEnable={onEnable} data = {table} renewSubscription = {renewSubscription} onEdit={onEdit} />
                    }
                </React.Fragment>
            }
            {Object.keys(subscription).length > 0 &&
            <RenewDialog 
                handleClose={handleClose} 
                isShowing={renewDialog.isShowing} 
                dialogType={renewDialog.dialogType}
                header={renewDialog.header}
                message={renewDialog.message}
                errorMessage={renewDialog.errorMessage}
                loading={state.loading} 
                subscription={(renewDialog.dialogType==='renew'|| renewDialog.dialogType==='update_client_subscription' || renewDialog.dialogType ==='update_ev_client_subscription')?subscription:{}} 
                renewSubscriptionData={renewSubscriptionData}
                updateClientSubscription={updateClientSubscription}
            /> }

            <PopUpDialog
                open={dialog.open}
                header={dialog.dialogHeader}
                content ={dialog.dialogContent}
                agreeBtnTxt ={dialog.dialogAgreeBtnTxt}
                disAgreeBtnTxt={dialog.dialogDisAgreeBtnTxt}
                isBtnDisabled={state.isBtnDisabled}
                agreeClicked ={updateSubscription}
                handleDialogClose={handleConfirmDialogClose}
            />    
            <SnackBar
                open={snackBar.open}
                handleClose={() => { setSnackBar({ open: false, msg: "" }); }}
                message={snackBar.msg}
                type={snackBar.type}
            />    
        </div>
    )
}

export default EVSubscription;